<!-- Main Modal -->
<div class="modal fade" [class.show]="isOpen" [style.display]="isOpen ? 'block' : 'none'" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
    <div class="modal-content">
      <!-- Header -->
      <div class="modal-header bg-light">
        <div>
          <h5 class="modal-title mb-1">
            <i class="bi bi-file-earmark-code text-warning me-2"></i>
            Quote Templates
          </h5>
          <p class="small text-muted mb-0">Manage HTML templates for quotation generation</p>
        </div>
        <button type="button" class="btn-close" (click)="close()"></button>
      </div>

      <!-- Body -->
      <div class="modal-body">
        <!-- Top Controls -->
        <div class="row mb-3">
          <div class="col-md-3">
            <input
              type="text"
              class="form-control"
              placeholder="Search..."
              [(ngModel)]="searchTerm"
              (input)="applyFilters()"
            />
          </div>
          <div class="col-md-2">
            <select class="form-select" [(ngModel)]="filterMode" (change)="applyFilters()">
              <option value="">Mode</option>
              <option *ngFor="let mode of shipmentModes" [value]="mode">{{ mode }}</option>
            </select>
          </div>
          <div class="col-md-2">
            <select class="form-select" [(ngModel)]="filterLoadType" (change)="applyFilters()">
              <option value="">Load Type</option>
              <option *ngFor="let type of containerLoadTypes" [value]="type.code">{{ type.code }}</option>
            </select>
          </div>
          <div class="col-md-2">
            <select class="form-select" [(ngModel)]="filterStatus" (change)="applyFilters()">
              <option value="">Status</option>
              <option *ngFor="let status of statuses" [value]="status">{{ status }}</option>
            </select>
          </div>
          <div class="col-md-3 text-end">
            <button class="btn btn-primary" (click)="openCreateModal()">
              <i class="bi bi-plus-circle me-1"></i> Create Template
            </button>
          </div>
        </div>

        <!-- Templates Table -->
        <div class="table-responsive">
          <table class="table table-hover">
            <thead class="table-light">
              <tr>
                <th>Name</th>
                <th>Mode</th>
                <th>Load Type</th>
                <th>Incoterm Scope</th>
                <th>Status</th>
                <th>Default</th>
                <th>Updated</th>
                <th class="text-end">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngIf="filteredTemplates.length === 0">
                <td colspan="8" class="text-center text-muted py-4">
                  <i class="bi bi-inbox fs-1 d-block mb-2"></i>
                  No quote templates found
                </td>
              </tr>
              <tr *ngFor="let template of filteredTemplates">
                <td><strong>{{ template.name }}</strong></td>
                <td><span class="badge bg-info">{{ template.shipmentMode }}</span></td>
                <td>{{ template.containerLoadType || '-' }}</td>
                <td>{{ template.incotermScope || 'ANY' }}</td>
                <td>
                  <span class="badge" [ngClass]="getStatusBadgeClass(template.status)">
                    {{ template.status }}
                  </span>
                </td>
                <td>
                  <i *ngIf="template.isDefault" class="bi bi-star-fill text-warning" title="Default Template"></i>
                  <span *ngIf="!template.isDefault" class="text-muted">-</span>
                </td>
                <td>{{ formatDate(template.updatedAt) }}</td>
                <td class="text-end">
                  <button
                    class="btn btn-sm btn-outline-primary me-1"
                    (click)="editTemplate(template)"
                    title="Edit"
                  >
                    <i class="bi bi-pencil"></i>
                  </button>
                  <button
                    class="btn btn-sm btn-outline-secondary me-1"
                    (click)="copyTemplate(template)"
                    title="Copy"
                  >
                    <i class="bi bi-files"></i>
                  </button>
                  <button
                    *ngIf="!template.isDefault"
                    class="btn btn-sm btn-outline-warning me-1"
                    (click)="setAsDefault(template)"
                    title="Set as Default"
                  >
                    <i class="bi bi-star"></i>
                  </button>
                  <button
                    class="btn btn-sm btn-outline-danger"
                    (click)="deleteTemplate(template)"
                    title="Delete"
                  >
                    <i class="bi bi-trash"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="close()">
          <i class="bi bi-x-circle me-1"></i> Close
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Create Template Modal -->
<div class="modal fade" [class.show]="showCreateModal" [style.display]="showCreateModal ? 'block' : 'none'" tabindex="-1" role="dialog" style="z-index: 1055;">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Create Quote Template</h5>
        <button type="button" class="btn-close" (click)="closeCreateModal()"></button>
      </div>
      <div class="modal-body">
        <form>
          <div class="mb-3">
            <label class="form-label">Template Name <span class="text-danger">*</span></label>
            <input
              type="text"
              class="form-control"
              placeholder="Enter template name"
              [(ngModel)]="newTemplate.name"
              name="name"
              required
            />
          </div>
          <div class="mb-3">
            <label class="form-label">Shipment Mode <span class="text-danger">*</span></label>
            <select class="form-select" [(ngModel)]="newTemplate.shipmentMode" name="shipmentMode" required>
              <option *ngFor="let mode of shipmentModes" [value]="mode">{{ mode }}</option>
            </select>
          </div>
          <div class="mb-3">
            <label class="form-label">Container Load Type</label>
            <select class="form-select" [(ngModel)]="newTemplate.containerLoadType" name="containerLoadType">
              <option value="">Select container load type</option>
              <option *ngFor="let type of containerLoadTypes" [value]="type.code">{{ type.code }} - {{ type.label }}</option>
            </select>
          </div>
          <div class="mb-3">
            <label class="form-label">Incoterm Scope</label>
            <select class="form-select" [(ngModel)]="newTemplate.incotermScope" name="incotermScope">
              <option value="">ANY</option>
              <option *ngFor="let incoterm of incoterms" [value]="incoterm.code">{{ incoterm.code }} - {{ incoterm.description }}</option>
            </select>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeCreateModal()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="createTemplate()">
          <i class="bi bi-plus-circle me-1"></i> Create Template
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Backdrop -->
<div class="modal-backdrop fade" [class.show]="isOpen || showCreateModal"
     *ngIf="isOpen || showCreateModal"
     [style.z-index]="showCreateModal ? '1054' : '1040'"></div>
